// extracted by mini-css-extract-plugin
export var csatScore = "_jw-5";
export var header = "_jw-1";
export var panelWrapper = "_jw-2";
export var postPreview = "_jw-3";
export var rightContent = "_jw-0";
export var wrappingText = "_jw-4";